import { connect } from "react-redux";
import { useRef, useEffect, useState } from "react";
import { getStatsColumnMapping } from "../../../../utils/columnsJsonInformation";
import "./PlayerStatsInformation.css";
import "../../../Skeleton/SkeletonLoader.css";
import SkeletonLoader from "../../../Skeleton/SkeletonLoader";
import { ratings } from "../../../../utils/utils";
import { ChevronRightIcon, ChevronLeftIcon } from "../../../../utils/icons";
import React from "react";
import {
  API_CONSTANTS,
  DEFAULT_OPTIMIZER,
  RECOMMENDATION_OPTIMIZERS,
} from "../../../../utils/constantInformation";
import { remoteConfig } from "../../../../firebase";
import { getStatsColorCoding } from "../../../../utils/statsColorCodingUtils";

function PlayerStatsInformation(props) {
  // console.log("PlayerStatsInformation store");
  // console.log(props.player_stat_information_store);
  const show_bottom_border = props.show_bottom_border;
  const background_dark = props.background_dark;

  const [horizontalScrollFlag, setHorizontalScrollFlag] = useState(null); // because mobile first approach
  const [width, setWidth] = useState(null); // because mobile first approach

  // some logic to scroll on click -- this will stop the need to have vertical scroll do horizontal for stats
  const refScroll = useRef();

  const scroll = (scrollOffset) => {
    refScroll.current.scrollLeft += scrollOffset;
  };

  // handle optimizer
  // all scenario optimizers need to be changed to Dream11ProjectedFantasyPoints

  const getOptimizer = () => {
    if (RECOMMENDATION_OPTIMIZERS.includes(props.optimizer)) {
      return DEFAULT_OPTIMIZER;
    } else {
      return props.optimizer;
    }
  };

  function isHorizontalScrollVisible() {
    var div = document.getElementById("stats-ul-scroll");
    if (div !== null) {
      var hs = div.scrollWidth > div.clientWidth;
      setWidth(div.scrollWidth);
      setHorizontalScrollFlag(hs);
    }
  }

  function useHorizontalScroll() {
    const elRef = useRef();
    useEffect(() => {
      const el = elRef.current;
      if (el) {
        const onWheel = (e) => {
          if (e.deltaY === 0) return;
          /*  If horizontal scroll is not available then it will scroll vertically,
              else complete the horizontal scroll and then continue vertical scrolling. */
          if (
            !(el.scrollLeft === 0 && e.deltaY < 0) &&
            !(
              el.scrollWidth - el.clientWidth - Math.round(el.scrollLeft) ===
                0 && e.deltaY > 0
            )
          ) {
            e.preventDefault();
          }
          //*************** */
          el.scrollTo({
            left: el.scrollLeft + e.deltaY * 5,
            behavior: "smooth",
          });
        };
        el.addEventListener("wheel", onWheel);
        return () => el.removeEventListener("wheel", onWheel);
      }
    }, []);

    return elRef;
  }
  const scrollRef = useHorizontalScroll();
  useEffect(() => {
    function handleResize() {
      isHorizontalScrollVisible();
    }
    isHorizontalScrollVisible();
    window.addEventListener("resize", handleResize);
  }, [horizontalScrollFlag, width]);
  return (
    <div className="row-parent">
      {horizontalScrollFlag ? (
        <div
          style={{ cursor: "pointer" }}
          onClick={() => scroll(-100)}
          className={`${
            show_bottom_border
              ? "stat-row-fade-left"
              : "stat-row-fade-left-nograd"
          } d-flex justify-content-start`}
        >
          <ChevronLeftIcon className="text-white align-items-center align-self-center enlarge-icon" />
        </div>
      ) : (
        <></>
      )}
      <div
        className={`  bg-secondary loop-parent scrolling-wrapper d-flex ${
          horizontalScrollFlag
            ? "justify-content-between"
            : "justify-content-between"
        } matrics pl-2 pr-2 ${show_bottom_border ? "border-bottom" : ""} ${
          background_dark ? "" : "bg-dark"
        }`}
        style={{
          background: background_dark === true ? "#000000" : "",
          scrollBehavior: "smooth",
        }}
        id="stats-ul-scroll"
        ref={refScroll}
        onResize={() => {
          console.log("Resize called");
          isHorizontalScrollVisible();
        }}
      >
        {props.player_stats.length == 0 ? (
          <div className="App">
            <SkeletonLoader className="w-100" number_of_cards={1} />
          </div>
        ) : props.lineup_card && props.league ? (
          getStatsColumnMapping(props.league, props.remoteConfig)
            .filter(
              (column) =>
                column.lineup_param == true &&
                column.display_name !== getOptimizer()
            )
            .map((information, index) => (
              <div
                className={`${
                  props.lineup_card ? "stat-box-small" : "stat-box"
                }`}
                // style={
                //   props.player_stat_information_store
                //     .playerStatInformationReducer[information.reducer_name] &&
                //   information.display_name != "Proj FP" &&
                //   information.show == true
                //     ? {}
                //     : { display: "none" }
                // }
              >
                <div
                  key={index}
                  className="align-items-center align-self-center p-2"
                >
                  {props.lineup_card ? (
                    <small>
                      <center>
                        <p className="stat_name text-center m-0 text-white ">
                          {information.display_name}
                        </p>
                      </center>
                    </small>
                  ) : (
                    <center>
                      <p className="stat-name text-center m-0 pb-1 text-white ">
                        {information.display_name}
                      </p>
                    </center>
                  )}

                  <p
                    className={`${
                      props.lineup_card
                        ? "m-0 pb-1 text-center font-weight-bold text-white stat_value"
                        : "lead m-0 pb-1 text-center font-weight-bold text-white stat_value"
                    }`}
                  >
                    {!information.default_value
                      ? information.display_name == "GPP RTG" ||
                        information.display_name == "H2H RTG"
                        ? ratings(props.player_stats[information.actual_name])
                        : props.player_stats[information.actual_name] ==
                          API_CONSTANTS.NUMERIC_CONSTANT
                        ? "--"
                        : Number(props.player_stats[information.actual_name])
                            .toFixed(1)
                            .replace(/\.0$/, "")
                      : "--"}
                  </p>
                </div>
              </div>
            ))
        ) : (
          props.league &&
          getStatsColumnMapping(props.league, props.remoteConfig).map(
            (information, index) => {

              return (
                <div
                  className={`${
                    props.lineup_card ? "stat-box-small" : "stat-box"
                  }`}
                  style={
                    props.player_stat_information_store
                      .playerStatInformationReducer[information.reducer_name] &&
                    information.display_name != "PFP" &&
                    information.show == true && props.player_stats[information.actual_name] != undefined
                      ? {}
                      : { display: "none" }
                  }
                >
                  <div
                    key={index}
                    className="align-items-center align-self-center p-2"
                  >
                    {props.lineup_card ? (
                      <small>
                        <center>
                          <p className="text-center m-0 text-white stat_name">
                            {information.display_name}
                          </p>
                        </center>
                      </small>
                    ) : (
                      <center>
                        <p className="text-center m-0 pb-1 text-white stat_name">
                          {information.display_name}
                        </p>
                      </center>
                    )}

                    <p
                      className={`${
                        props.lineup_card
                          ? "m-0 pb-1 text-center font-weight-bold text-white stat_value"
                          : "lead m-0 pb-1 text-center font-weight-bold text-white stat_value"
                      }`}
                      style={{
                        backgroundColor : getStatsColorCoding(props, information)
                      }}
                    >
                      {!information.default_value
                        ? information.display_name == "GPP RTG" ||
                          information.display_name == "H2H RTG"
                          ? ratings(props.player_stats[information.actual_name])
                          : props.player_stats[information.actual_name] ==
                            API_CONSTANTS.NUMERIC_CONSTANT
                          ? "--"
                          : props.player_stats[information.actual_name]
                        : "--"}
                    </p>
                  </div>
                </div>
              )
            }
          )
        )}
      </div>
      {horizontalScrollFlag ? (
        <div
          style={{ cursor: "pointer" }}
          className={`${
            show_bottom_border ? "stat-row-fade" : "stat-row-fade-nograd"
          } d-flex justify-content-end`}
          onClick={() => scroll(100)}
        >
          <ChevronRightIcon className="text-white  align-items-center align-self-center enlarge-icon" />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    player_stat_information_store: state,
    league: state.gameInformationReducer.sports,
    remoteConfig: state.rcReducer,
  };
};
export default connect(mapStateToProps)(PlayerStatsInformation);
